import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/**
 * Портал для модалок: рендерит в document.body, чтобы modal-backdrop не
 * зависел от stacking context'а родителя (например, sticky-сайдбара —
 * внутри него z-index не спасает, модалка уходит под контент страницы).
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
